import Component from '../abstracts/Component';

export default class ArticleGalleryComponent extends Component {

  get COMPONENTNAME() {
    return 'ArticleGalleryComponent';
  }

  get SELECTORS() {
    return {
      bigCarousel: '[data-ag-big-carousel]',
      smallCarousel: '[data-ag-small-carousel]',
      prevArrow: '[data-ag-prev-arrow]',
      nextArrow: '[data-ag-next-arrow]',
      index: '[data-ag-index]',
      slide: '[data-ag-slide]',
      total: '[data-ag-total]',
      current: '[data-ag-current]',
      title: '[data-title]',
      titleContent: '[data-title-content]',
      titleText: '[data-title-text]',
    };
  }

  constructor(compEl) {
    super(compEl);
    this.bigCarousel = this.$component.querySelector(this.SELECTORS.bigCarousel);
    this.slides = this.bigCarousel.querySelectorAll(this.SELECTORS.slide);
    this.smallCarousel = this.$component.querySelector(this.SELECTORS.smallCarousel);
    this.prevArrow = this.$component.querySelector(this.SELECTORS.prevArrow);
    this.nextArrow = this.$component.querySelector(this.SELECTORS.nextArrow);
    this.index = this.$component.querySelector(this.SELECTORS.index);
    this.total = this.$component.querySelector(this.SELECTORS.total);
    this.current = this.$component.querySelector(this.SELECTORS.current);
    this.title = this.$component.querySelector(this.SELECTORS.title);
    this.titleContent = this.$component.querySelector(this.SELECTORS.titleContent);
    this.titleText = this.$component.querySelector(this.SELECTORS.titleText);
  }

  initSliders() {
    let configBig = {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      infinite: true,
      swipe: true,
      draggable: false,
    };
    let configSmall = {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      infinite: true,
      swipe: false,
      draggable: false,
      initialSlide: 1,
    };
    let big = $(this.bigCarousel).slick(configBig);
    let small = $(this.smallCarousel).slick(configSmall);

    // events
    $(big).on('swipe', (e, slick, dir) => {
      if (dir === 'left') {
        small.slick('slickNext');
      } else {
        small.slick('slickPrev');
      }
    });
    this.setIndex();
    this.prevArrow.addEventListener('mousedown', () => {
      this.prevArrow.classList.remove('transition');
    });
    this.prevArrow.addEventListener('click', () => {
      this.prevArrow.classList.add('transition');
      big.slick('slickPrev');
      small.slick('slickPrev');
    });
    this.nextArrow.addEventListener('mousedown', () => {
      this.nextArrow.classList.remove('transition');
    });
    this.nextArrow.addEventListener('click', () => {
      this.nextArrow.classList.add('transition');
      big.slick('slickNext');
      small.slick('slickNext');
    });
    $(big).on('beforeChange', () => {
      this.current.classList.remove('show');
      this.title.classList.add('transition');
    });
    $(big).on('afterChange', (e, slick, curr) => {
      this.current.innerText = curr + 1;
      this.current.dataset.slide = curr + 1;
      this.current.classList.add('transition');
      setTimeout(() => {
        this.current.classList.remove('transition');
        this.current.classList.add('show');
        this.title.classList.remove('transition');
      }, 10);
    });
  }

  setIndex() {
    this.total.innerText = this.slides.length;
    this.current.innerText = '1';
    this.current.dataset.slide = '1';
  }

  importSlick() {
    this.moduleLoader.loadCarouselAndExecute(
      module => {
        this.initSliders();
      },
      error => {
        console.error('failed to load slick', error.stack);
      }
    );
  }

  setTitleWidth() {
    let width = this.titleText.getBoundingClientRect().width;
    this.titleContent.style.width = `${width}px`;
  }

  render() {
    this.log('Rendering...');
    this.setTitleWidth();
    try {
      this.importSlick();
    } catch (e) {
      console.log(e);
    }
  }
}
